export class WebSocketNotificationUpdateRequest {
    public listIdUser: number[];
}